import React, { useState } from "react";

interface Tab {
  title: string;
  component?: React.ComponentType<any> | JSX.Element;
}

interface Props {
  defaultSelectedIndex?: number;
  header?: React.ComponentType<any>;
  tabs: Tab[];
  tabsLabel?: string;
  componentRender?: (
    selectedIndex: number
  ) => React.ComponentType<any> | JSX.Element;
}

export default function PromineoTabs(props: Props) {
  const {
    defaultSelectedIndex,
    tabsLabel,
    header: HeaderComponent,
    tabs,
    componentRender,
  } = props;
  const [selectedIndex, setSelectedIndex] = useState(defaultSelectedIndex || 0);

  const handleTabSelection = (index: number) => {
    setSelectedIndex(index);
  };

  const TabHeaders = () => {
    return (
      <div className="flex items-center">
        {tabsLabel ? (
          <span className="mr-4 text-sm font-medium">{tabsLabel}: </span>
        ) : (
          ""
        )}
        <div className="rounded-md bg-promGray3 p-0.5 flex">
          {tabs.map((tab: Tab, idx: number) => {
            return (
              <div
                className={`rounded py-px px-3 cursor-pointer text-sm font-semibold ${
                  selectedIndex === idx
                    ? "bg-primaryRed text-white"
                    : "text-promGray"
                } `}
                onClick={() => handleTabSelection(idx)}
                key={idx}
              >
                {tab.title}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const SelectedComponent = () => {
    if (
      tabs &&
      tabs.length &&
      tabs[selectedIndex] &&
      tabs[selectedIndex].component
    ) {
      const Component: React.ComponentType<any> = tabs[selectedIndex]
        .component as React.ComponentType<any>;
      return <Component />;
    }
    return <></>;
  };

  return (
    <div className="bg-white py-4 rounded shadow-custom">
      <div className="flex justify-between items-center px-6">
        {HeaderComponent ? <HeaderComponent /> : <span>&nbsp;</span>}
        {tabs.length > 1 && <TabHeaders />}
      </div>
      <div className="mt-4">
        {componentRender ? (
          componentRender(selectedIndex)
        ) : (
          <SelectedComponent />
        )}
      </div>
    </div>
  );
}
